<div class="common-text-input__container"
  [id]="field.id">
  <div class="common-text-input__container-box"
    [ngClass]="{'common-text-input__container-box--focused': fieldTypeOther.showList,
      'common-text-input__container-box--error': field.error}"
    [attr.disabled]="field.noEditable?true:null"
    #containerFieldOther>
    <div class="field-type-other__field-container">
      <div class="common-text-input__container-box-inner-list">
        <div class="common-text-input__block-header">
          <div class="common-text-input__label-no-cursor">
            <span class="common-text-input__text-label">{{fieldTypeOther.titleField}}</span>
            @if(field.required){
              <span class="common-tag__mandatory-text-asterisk">*</span>
            }
            <div class="common-text-input__block-buttons">
              @if (field.description) {
                <tooltip-info [description]="field.description"
                [field]="field"></tooltip-info>
              }
              @if (field.references?.length) {
                <tooltip-law [references]="field.references"
                [field]="field"></tooltip-law>
              }
              @if (field.relatedInfo?.length){
                <button class="common-button__icon-sm-noborder"
                  pTooltip="{{'common.related-info'| afTranslate}}"
                  tooltipPosition="top"
                  (click)="openModalRelatedInfo(field.relatedInfo, $event)">
                  <i class="lf-icon-search-text common-icon__md"></i>
                </button>
              }
              @if (field.inReport !== null && field.inReport !== undefined && !isLanding){
                <tooltip-in-report [inReport]="fieldTypeOther.inReport"></tooltip-in-report>
              }
            </div>
          </div>
          <div class="common-text-input__buttons-right-header">
            @if(field.multiple && fieldTypeOther.listElementSelect?.length){
              <div class="common-badge__badge-block">
                <span class="common-badge__square-md">{{fieldTypeOther.listElementSelect.length}}</span>
              </div>
            }
            @if(fieldTypeOther.chargedList){
              <div>
                <button class="common-button__icon-sm-noborder"
                  [disabled]="field.noEditable || userPermissions === 'none'"
                  (click)="toggleFilter($event)">
                  <i class="common-icon__md"
                    [ngClass]="fieldTypeOther.showList?'lf-icon-angle-up':'lf-icon-connected-data'"></i>
                </button>
                @if(!field.noEditable && userPermissions !== 'none'){
                  <p-overlayPanel #fieldTypeOtherOverlay
                    styleClass="common-dropdown-list__overlay-field-list"
                    (onShow)="fieldTypeOther.showList = true"
                    (onHide)="fieldTypeOther.showList = false">
                    <ng-template pTemplate="content">
                      <div class="common-dropdown-list__overlay-field-list-container"
                        [ngStyle]="{'width': containerFieldOtherElement.nativeElement?.offsetWidth+'px'}">
                        <div class="common-dropdown-list__overlay-header-search-container">
                          <div class="common-search__container-tonal">
                            <div class="common-search__container-input-text">
                              <input type="search"
                                class="common-search__input-text"
                                [(ngModel)]="fieldTypeOther.findDropdown"
                                placeholder="{{'common.search-item' | afTranslate}}">
                            </div>
                            <div class="common-search__block-button-search">
                              @if(fieldTypeOther.findDropdown){
                                <button class="common-button__icon-xs-noborder"
                                  (click)="fieldTypeOther.findDropdown = ''">
                                  <i class="lf-icon-close-thick common-icon__sm"></i>
                                </button>
                              }
                              <div class="h-[22px]"
                                ngClass="{{fieldTypeOther.findDropdown?'common-divider__vertical-main-1000':'common-divider__vertical-grey-400'}}"></div>
                                <i class="lf-icon-search common-icon__md"
                                  ngClass="{{!fieldTypeOther.findDropdown?'common-search__icon-search-disabled':'common-search__icon-search-enabled'}}"></i>
                              </div>
                          </div>
                          @if (!isLanding) {
                            <button class="common-button__icon-md-border"
                              pTooltip="{{fieldTypeOther.tooltipText}}"
                              tooltipPosition="top"
                              (click)="generateNew()">
                              <i class="lf-icon-sum common-icon__md"></i>
                            </button>
                          }
                        </div>
                        <div class="common-dropdown-list__overlay-list-container">
                          @for (listValue of listValues | byWord:fieldTypeOther.findDropdown:['data']; track $index) {
                            <div class="common-dropdown-list__user-item"
                              [attr.disabled]="listValue.disabled || field.noEditable?true:null">
                              <div class="common-button__block-button-md-checkbox">
                                <button class="common-button__icon-md-checkbox"
                                  [ngClass]="{'common-button__icon-md-checkbox--selected': listValue.selected}"
                                  [disabled]="listValue.disabled || field.noEditable"
                                  (click)="selectValue(listValue)">
                                  <i class="common-icon__md"
                                    [ngClass]="{'lf-icon-radio-button-active': listValue.selected && !field.multiple,
                                      'lf-icon-step-first': !listValue.selected && !field.multiple,
                                      'lf-icon-check-full': listValue.selected && field.multiple,
                                      'lf-icon-box-inactive': !listValue.selected && field.multiple}"></i>
                                </button>
                              </div>
                              <div class="common-dropdown-list__user-item-wrapper"
                                (click)="selectValue(listValue)">
                                <span-tooltip class="common-dropdown__list-text-title"
                                  [ngClass]="{'common-dropdown__list-text-title--no-data': listValue.noName}"
                                  [text]="listValue.data"
                                  [isDeleted]="listValue.isDeleted"></span-tooltip>
                              </div>
                              @if(!field.isClientField && !isLanding){
                                <div class="common-dropdown-list__user-item-options">
                                  <button class="common-button__icon-sm-noborder"
                                    pTooltip="{{fieldTypeOther.tooltipList}}"
                                    tooltipPosition="left"
                                    (click)="viewRelatedConcept($event, listValue)">
                                      <i class="lf-icon-visible common-icon__md"></i>
                                  </button>
                                </div>
                              }
                            </div>
                          }
                          <!-- @empty {
                            <div class="common-empty-state__message-list"
                              [afTranslate]="'field-type-list.empty-associated-templates'">_Este concepto no tiene plantillas asociadas</div>
                          } -->
                        </div>
                      </div>
                    </ng-template>
                  </p-overlayPanel>
                }
              </div>
            }
          </div>
        </div>
        <div class="common-list__list-group min-h-[22px]">
          @if (field.multiple){
            @for (listElement of fieldTypeOther.listElementSelect; track $index){
              <div class="common-chips__standard"
                [ngClass]="{'common-chips__standard--error': listElement.noName}"
                [attr.disabled]="field.noEditable?true:null">
                <span-tooltip class="common-chips__label-text"
                  [text]="listElement.data"></span-tooltip>
                @if (!field.noEditable && userPermissions !== 'none'){
                  <button class="lf-icon-close-round common-icon__sm common-chips__icon-close"
                    (click)="addOrDeleteSelectedValue(listElement)"></button>
                }
              </div>
            }
          }@else {
            <div class="common-text-input__block-selected-item"
              [ngClass]="{'common-text-input__block-selected-item--with-value': fieldTypeOther.conceptSelected.data && !field.noEditable}">
              <span-tooltip class="common-text-input__selected-option"
                  [attr.disabled]="field.noEditable?true:null"
                  [text]="fieldTypeOther.conceptSelected.data"></span-tooltip>
              @if (fieldTypeOther.conceptSelected.data && !field.noEditable) {
                <button class="common-text-input__icon-clean-input"
                  (click)="resetItemSelect()">
                  <i class="lf-icon-close-thick common-icon__sm"></i>
                </button>
              }
            </div>
          }
        </div>
      </div>
      @if ((fieldTypeOther.selectRelated?.length || fieldTypeOther.conceptSelected?.data) && !field.lcoIsUngroupedView) {
        <div class="field-type-other__block-content">
          <div class="field-type-other__concept-block">
            <p class="field-type-other__concept-text"
              [ngClass]="{'field-type-other__concept-text--error': fieldTypeOther.conceptSelected.noName}">{{fieldTypeOther.conceptSelected.data}}</p>
            @if (!isLanding && !((field.noEditable || userPermissions ==='none') && !fieldTypeOther.icamUser)) {
              <button class="common-button__icon-md-noborder"
                (click)="viewRelatedConcept($event, fieldTypeOther.conceptSelected)">
                <i class="lf-icon-editable-form common-icon__md"></i>
              </button>
            }
          </div>
          <div class="field-type-other__concept-fields-block">
            <ul class="field-type-other__concept-fields-list">
              @for (related of fieldTypeOther.selectRelated; track $index) {
                <li class="field-type-other__concept-fields-item-block">
                  <div class="field-type-other__concept-fields-item">
                    <span>
                      {{related.label}}:
                    </span>
                    <span class="field-type-other__concept-fields-item field-type-other__concept-fields-item--value">
                      {{related.data}}
                    </span>
                  </div>

                </li>
              }
              @if (fieldTypeOther.sameConcept) {
                <li class="field-type-other__concept-fields-item">
                  <!-- common-textarea__label-container--error -->
                  <label
                    for="text-area-text-default"
                    class="common-textarea__label-container mb-4">
                    <p class="common-textarea__label-title">
                      <span [afTranslate]="'field-type-other.relationship-reason'">
                        _Motivo de la relación
                      </span>
                    </p>
                    <div class="common-textarea__label-input-container">
                      <textarea
                        id="text-area-text-default"
                        class="common-textarea__label-input-text"
                        [(ngModel)]="fieldTypeOther.relationshipList[fieldTypeOther.listOtherMultipleIndex]"
                        autocomplete="off"
                        pInputTextarea
                        [autoResize]="true"
                        [rows]="1"></textarea>
                    </div>
                  </label>
                </li>
              }
            </ul>
            @if (field.multiple) {
              <div class="field-type-other__pagination-block">
                <button class="common-button__icon-sm-noborder"
                  [disabled]="fieldTypeOther.listOtherMultipleIndex === 0"
                  (click)="goTo('prev')">
                  <i class="lf-icon-angle-left common-icon__md"></i>
                </button>
                <span class="field-type-other__pagination-text">{{fieldTypeOther.listOtherMultipleIndex + 1}}</span>
                <button class="common-button__icon-sm-noborder"
                  [disabled]="fieldTypeOther.listOtherMultipleIndex >= (fieldTypeOther.listElementSelect.length - 1)"
                  (click)="goTo('next')">
                  <i class="lf-icon-angle-right common-icon__md"></i>
                </button>
              </div>
            }
          </div>
        </div>
      }@else if(field.lcoIsUngroupedView && fieldTypeOther.relatedList?.length){
        <div class="field-type-other__list-content">
          @for (related of fieldTypeOther.relatedList; track $index) {
            <div class="field-type-other__block-list-content">
              <div class="field-type-other__concept-block">
                <p class="field-type-other__concept-text"
                  [ngClass]="{'field-type-other__concept-text--error': fieldTypeOther.listElementSelect[$index].noName}">{{fieldTypeOther.listElementSelect[$index].data}}</p>
                @if (!isLanding && !((field.noEditable || userPermissions ==='none') && !fieldTypeOther.icamUser)) {
                  <button class="common-button__icon-md-noborder"
                    (click)="viewRelatedConcept($event, fieldTypeOther.listElementSelect[$index])">
                    <i class="lf-icon-editable-form common-icon__md"></i>
                  </button>
                }
              </div>
              <div class="field-type-other__concept-fields-block">
                <ul class="field-type-other__concept-fields-list">
                  @for (selectRelated of related; track $index) {
                  <li class="field-type-other__concept-fields-item">
                    <span>{{selectRelated.label}}:</span>
                    <span class="field-type-other__concept-fields-item field-type-other__concept-fields-item--value">{{selectRelated.data}}</span>
                  </li>
                  }
                  @if(fieldTypeOther.sameConcept){
                    <!-- common-textarea__label-container--error -->
                    <li class="field-type-other__concept-fields-item">
                      <label for="text-area-text-default"
                        class="common-textarea__label-container mb-4">
                        <p class="common-textarea__label-title">
                          <span [afTranslate]="'field-type-other.relationship-reason'">_Motivo de la relación</span>
                        </p>
                        <div class="common-textarea__label-input-container">
                          <textarea id="text-area-text-default" class="common-textarea__label-input-text"
                            [(ngModel)]="fieldTypeOther.relationshipList[fieldTypeOther.listOtherMultipleIndex]"
                            autocomplete="off" pInputTextarea [autoResize]="true" [rows]="1"></textarea>
                        </div>
                      </label>
                    </li>
                  }
                </ul>
              </div>
            </div>
          }
      </div>
      }
    </div>
  </div>
  @if(field.error){
    <div class="common-text-input__mandatory-tag">
      @if(field.blocker){
        <i class="lf-icon-warning common-icon__error-md"></i>
      }
      <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
    </div>
  }
</div>
